import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    description: Yup.string().required('Required').nullable(),
    currencyId: Yup.number().required('Required').nullable(),
  });
